import { render, staticRenderFns } from "./EnterHolidays.vue?vue&type=template&id=2c2bbdd2&scoped=true"
import script from "./EnterHolidays.vue?vue&type=script&lang=js"
export * from "./EnterHolidays.vue?vue&type=script&lang=js"
import style0 from "./EnterHolidays.vue?vue&type=style&index=0&id=2c2bbdd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2bbdd2",
  null
  
)

export default component.exports